import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonItem, IonMenuButton, IonPage, IonTitle, IonToolbar, useIonAlert, useIonToast } from "@ionic/react"
import { createOutline, personAddOutline, refreshOutline, trashOutline } from "ionicons/icons"
import { useEffect, useState } from "react"
import { useHistory, useLocation } from 'react-router-dom'
import { DivH } from "../../../components/divh/styled"
import Loading from "../../../components/loading"
import { Group } from "../../../dto/group"
import { deleteGroup, findData } from "./service"

const GroupList: React.FC = () => {
  const [data, setData] = useState(undefined as Group[] | undefined)
  const isLoadingData = !data
  const [presentAlert] = useIonAlert()
  const history = useHistory(); //chamado do hook
  const [present] = useIonToast();

  const location = useLocation()

  const find = async () => {
    const data: Group[] = await findData()
    setData(data)
  }

  useEffect(() => {
    if (!data) {
      find()
    }
  }, [data])

  useEffect(() => {
    const sta = location?.state as any
    if (sta && sta.refresh) {
      setData(undefined)
    }
  }, [location?.state])

  const deleteConfirm = (group: Group) => {
    return presentAlert({
      header: "Excluir grupo",
      message: "<span> Deseja excluir o grupo <b>'" + group.name + "'</b> </span> ?",
      buttons: [
        {
          text: "Confirmar",
          role: "confirm",
          handler: async () => {
            await deleteGroup(group)
            present({
              message: "Grupo '" + group.name + "' deletado com sucesso.",
              duration: 1_500,
              position: 'top'
            })
            find()
          }
        },
        {
          text: "Cancelar",
          role: "cancel"
        }
      ]
    })
  }

  const edit = (group: Group) => {
    history.push('/group/form', group);
  }

  const buildContent = () => {
    return <>
      {data!.map((group) => {
        return (
          <IonItem key={group.id}>
            <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <DivH style={{ justifyContent: 'flex-start', height: '100%' }}>
                <span>
                  {group.name}
                </span>
              </DivH>

              <IonButtons>
                <IonButton onClick={() => edit(group)}>
                  <IonIcon icon={createOutline} />
                </IonButton>
                <IonButton onClick={() => deleteConfirm(group)}>
                  <IonIcon icon={trashOutline} />
                </IonButton>
              </IonButtons>
            </div>
          </IonItem>
        )
      })}
    </>
  }

  return (
    <IonPage>

      <IonHeader style={{ marginBottom: "1em" }}>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>

          <IonTitle  style={{ marginLeft: '1em' }} >Grupos de acesso</IonTitle>

          <IonButtons slot="end">

            <IonButton color="light" onClick={(e) => { find() }}>
              <IonIcon icon={refreshOutline} />
              
            </IonButton>
            <IonButton color="light" onClick={() => { history.push('/group/form', new Group()) }}>
              <IonIcon icon={personAddOutline} />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>

        {isLoadingData &&
          <Loading />
        }
        {!isLoadingData &&
          buildContent()
        }

      </IonContent>
    </IonPage>
  )
}

export default GroupList
